// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WebHook__type-checkbox {
  margin-left: 48px;
}

.WebHook__box-footer {
  z-index: 2;
  border-top-color: #d6d6d6;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/Settings/Integration/WebHooks/WebHooks.css","webpack://./services/frontend/app/pages/Settings/Integration/WebHooks/WebHooks.css"],"names":[],"mappings":"AADA;ECEE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":[".WebHook__type-checkbox {\n  margin-left: 48px;\n}\n\n.WebHook__box-footer {\n  border-top-color: #d6d6d6;\n  z-index: 2;\n}\n",".WebHook__type-checkbox {\n  margin-left: 48px;\n}\n\n.WebHook__box-footer {\n  z-index: 2;\n  border-top-color: #d6d6d6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
